<template>
    <div v-if="data">
        <div v-if="!detailLayout" class="row align-items-baseline ad-title-row">
            <div class="col-10 AdName">
                {{PagesTitle.Title}}
                <slot name="info"></slot>
            </div>
            <div class="col-2 AdName_p AdName_p_Id">
                {{ data.adDetailId ? 'ID#' + data.adDetailId : '' }}
            </div>
            <div class="col-12 AdName_p ">
                {{PagesTitle.Title_P}}
            </div>
        </div>
        <div  class=" Ad-Top">
            <div class="AdDataName AdDataName--effective">
                {{ $t('lbl_EMPBE_Ad_Effective_Period') }}
            </div>
            <span class="Ad-EffectiveDateStart">
                <custom-date :date="data.effectiveDateFrom" :args="'yyyy-M-d'"></custom-date>
                {{ $t("lbl_EMPBE_To").toLowerCase() }}
                <custom-date :date="data.effectiveDateTo" :args="'yyyy-M-d'"></custom-date>
            </span>
            <slot :name="'ProductSelect'"></slot>
            <div class="Ad-Top" v-if="PagesTitle.TriggeringCondition">
                <div class=" AdDataName">
                    {{PagesTitle.TriggeringCondition}}
                </div>
                <div class=" AdName_p ">
                    {{PagesTitle.TriggeringCondition_P}}
                </div>
            </div>
        </div>
    </div>


</template>
<script>
export default {
    props: {
        data: { type: Object, default: null },
        PagesTitle: { type: Object, default: null },
        detailLayout: { type: Boolean, default: false },
    },
}
</script>